import React, { useState } from "react";
import * as XLSX from "xlsx";
import api from "../api";

const SmsPage = () => {
  const [mobiles, setMobiles] = useState("");
  const [message, setMessage] = useState("");
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);

  const validateMobiles = (input) => input.replace(/[^0-9,]/g, "");
  const validateMessage = (text) => text.replace(/[<>]/g, "").slice(0, 1000);

  // Function to generate and download the single-column template
  const downloadTemplate = () => {
    const data = [
      ["0911000000"], // Sample number 1
      ["0912000000"], // Sample number 2
    ];
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
    XLSX.writeFile(workbook, "sms_template.xlsx");
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = evt.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const firstSheet = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], {
        header: 1,
      });
      const numbers = sheetData.flat().filter(Boolean).join(",");
      setMobiles(validateMobiles(numbers));
    };
    reader.readAsBinaryString(file);
  };

  const sendSms = async () => {
    let sanitizedMobiles = validateMobiles(mobiles);
    if (sanitizedMobiles.endsWith(",")) {
      sanitizedMobiles = sanitizedMobiles.slice(0, -1);
    }
    const sanitizedMessage = validateMessage(message);

    if (!sanitizedMobiles) return alert("Please enter valid mobile numbers");
    if (!sanitizedMessage) return alert("Message cannot be empty");

    setLoading(true);
    try {
      const res = await api.post("/sms", {
        recipient: sanitizedMobiles,
        message: sanitizedMessage,
      });
      alert("SMS Sent successful!");
      setReport(res.data);
      setMobiles("");
      setMessage("");
    } catch (err) {
      alert("Failed to send SMS");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex justify-center items-start py-10 px-4">
      <div className="w-full max-w-3xl bg-white rounded-2xl shadow-lg p-8 space-y-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center">
          Send Bulk SMS
        </h2>

        {/* Excel Upload & Template Link */}
        <div>
          <div className="flex justify-between items-end mb-2">
            <label className="block font-medium text-gray-700">
              Upload Excel (Mobiles)
            </label>

            <button
              onClick={downloadTemplate}
              className="text-sm font-semibold text-green-700 hover:text-green-800 hover:underline flex items-center gap-1"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                />
              </svg>
              Excell Template
            </button>
          </div>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileUpload}
            className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4
              file:rounded-lg file:border-0 file:text-sm file:font-semibold
              file:bg-green-100 file:text-green-700 hover:file:bg-green-200"
          />
        </div>

        {/* Mobile Numbers */}
        <div>
          <label className="block font-medium text-gray-700 mb-2">
            Mobile Numbers
          </label>
          <textarea
            required
            value={mobiles}
            onChange={(e) => setMobiles(validateMobiles(e.target.value))}
            placeholder={
              "Comma-separated mobile numbers like below \n0911000000,0912000000"
            }
            rows={4}
            className="whitespace-pre-line w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-green-300 focus:outline-none"
          />
        </div>

        {/* Message */}
        <div>
          <label className="block font-medium text-gray-700 mb-2">
            Message (max 1000 chars)
          </label>
          <textarea
            required
            value={message}
            onChange={(e) => setMessage(validateMessage(e.target.value))}
            placeholder="Type your message"
            rows={6}
            className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-green-300 focus:outline-none"
          />
          <div className="text-right text-sm text-gray-500">
            {message.length}/1000
          </div>
        </div>

        {/* Submit Button */}
        <button
          onClick={sendSms}
          disabled={loading}
          className={`w-full py-3 rounded-lg text-white font-semibold ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700"
          } transition duration-300`}
        >
          {loading ? "Sending..." : "Send SMS"}
        </button>

        {/* Report */}
        {report && (
          <div className="bg-gray-100 p-4 rounded-lg mt-6">
            <h3 className="text-xl font-semibold mb-2">Report</h3>
            <pre className="text-sm text-gray-700 overflow-x-auto">
              {JSON.stringify(report, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default SmsPage;
